// external libraries
import { useTranslation } from 'react-i18next';

// types
import type { GridColDef } from '@mui/x-data-grid-pro';
import type { DutyLineWithAudit } from 'RestAPIs/employees/hours-table/types';

// utils
import {
  dateAndTimeFormatter,
  nestedFieldValueGetter,
  timeFormatter
} from 'utils/grid';

export const useGetDutyHistoryPeriodsColumns =
  (): GridColDef<DutyLineWithAudit>[] => {
    'use memo';

    const { t: tRoot } = useTranslation('common');
    const { t } = useTranslation('common', {
      keyPrefix: 'hoursTable.dutyInformation'
    });

    return [
      {
        headerName: t('updatedDate'),
        field: 'audit.operationTimestamp',
        type: 'string',
        editable: false,
        valueGetter: (_, row: DutyLineWithAudit) =>
          nestedFieldValueGetter('audit.operationTimestamp', row),
        valueFormatter: dateAndTimeFormatter,
        flex: 1
      },
      {
        headerName: t('updatedBy'),
        field: 'audit.operationUserName',
        type: 'string',
        editable: false,

        valueGetter: (_, row: DutyLineWithAudit) =>
          nestedFieldValueGetter('audit.operationUserName', row),
        flex: 1
      },
      {
        headerName: t('periodId'),
        field: 'dutyLinePeriodId',
        type: 'string',
        headerAlign: 'center',
        align: 'center',
        width: 80,
        editable: false
      },
      {
        headerName: t('operation'),
        field: 'audit.operation',
        type: 'string',
        headerAlign: 'center',
        align: 'center',
        width: 60,
        editable: false,
        valueGetter: (_, row: DutyLineWithAudit) =>
          nestedFieldValueGetter('audit.operation', row)
      },
      {
        headerName: tRoot('dutyHourType'),
        field: 'dutyTypeDescription',
        type: 'string',
        editable: false,
        flex: 1
      },
      {
        headerName: t('dccCode'),
        field: 'dccCode',
        type: 'string',
        headerAlign: 'center',
        align: 'center',
        width: 120,
        editable: false
      },
      {
        headerName: tRoot('startTime'),
        field: 'startTime',
        type: 'string',
        editable: false,
        valueFormatter: timeFormatter,
        flex: 1
      },
      {
        headerName: tRoot('endTime'),
        field: 'endTime',
        type: 'string',
        editable: false,
        valueFormatter: timeFormatter,
        flex: 1
      }
    ] satisfies GridColDef[];
  };
